
$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }else{
          This.removeClass('active');
        }
    });
  });

  var mainSwiper = new Swiper('#cloud', {
    // パラメーター
    loop: true,
    slidesPerView: 6,
    speed:20000,
    centeredSlides: true,
    preventInteractionOnTransition: true,
    loopAdditionalSlides: 1,
    allowTouchMove: false,
    autoplay: {delay: 0},
    breakpoints: {
      2240: {
        slidesPerView: 5,
      },
      1920: {
        slidesPerView: 4,
      },
      1480: {
        slidesPerView: 3,
      },
      1100: {
        slidesPerView: 2,
      }
    }
  });
  $(window).resize(function(){
      mainSwiper.autoplay.paused = false;
      mainSwiper.autoplay.start();
  });

  $('.header_menu_btn').click(function(){
    if ($('.header_wrapper').hasClass('open')) {
      $('.header_menu_btn span').html('MENU');
    }else{
      $('.header_menu_btn span').html('CLOSE');
    }
    $('.header_wrapper').toggleClass('open');
  });
  $('.header_menu ul li a').click(function(){
    if ($('.header_wrapper').hasClass('open')) {
      $('.header_menu_btn span').html('MENU');
    }else{
      $('.header_menu_btn span').html('CLOSE');
    }
    $('.header_wrapper').toggleClass('open');
  });

});
